export default __webpack_public_path__ + "static/media/sensotrend_signin_set_pwd.b8c74f08.png";